/**
 * Create reducers set given the initial state and reducers
 * @param initialState  Initial state for a given reducers set
 * @param reducers The reducers set
 */
export const createReducers = (initialState: any, reducers: any) =>
	(state = initialState, action: any) =>
		reducers.hasOwnProperty(action.type) ? reducers[action.type](state, action) : state;
